export interface FieldErrorLeaf {
  path: string;
  message: string;
}

const errorMetadataKeys = ['ref', 'type', 'types', 'message'];

function isTraversableNode(value: unknown): boolean {
  return typeof value === 'object' && value !== null;
}

export function flattenFieldErrors(errors: unknown): FieldErrorLeaf[] {
  const leaves: FieldErrorLeaf[] = [];

  const isRootContainer = (path: string | null) => path === null;

  const collectFrom = (node: unknown, path: string | null) => {
    if (!isTraversableNode(node)) return;

    const { message } = node as { message?: unknown };
    if (!isRootContainer(path) && typeof message === 'string' && message) {
      leaves.push({ path: path as string, message });
    }

    const pathTo = (key: string | number) =>
      isRootContainer(path) ? `${key}` : `${path}.${key}`;

    if (Array.isArray(node)) {
      node.forEach((entry, index) => collectFrom(entry, pathTo(index)));
      return;
    }

    Object.entries(node as Record<string, unknown>).forEach(([key, value]) => {
      if (errorMetadataKeys.includes(key)) return;
      collectFrom(value, pathTo(key));
    });
  };

  collectFrom(errors, null);

  return leaves;
}
